module.exports = __webpack_public_path__ + "files/f5d66fc87d0d1dca334ad1f60d1f68cf.png";